import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { PropertySummaryPreviewComponent } from './property-summary-preview.component';

@NgModule({
  declarations: [
    PropertySummaryPreviewComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    PropertySummaryPreviewComponent
  ]
})
export class PropertySummaryPreviewModule { }
